import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { TslDialog } from '@tesla/ng-tds';
import { AgencyType, DiversityType, SupplierDiversity } from 'app/profile/models/onboarding.model';
import { Tab } from 'app/profile/models/stage.model';
import { SupplierDiversityPropertyValue } from 'app/profile/models/supplier.model';
import { GetDiversityTypes, GetAgencyTypes, GetSupplierDiversityByCode, SetCurrentSupplierCode,GetPreventativeInProgress } from 'app/profile/store/app.actions';
import { SelectDiversityTypes, SelectAgencyType, SelectSupplierDiversity,SelectPreventativeInProgress } from 'app/profile/store/app.selector';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { getSupplierDiversity } from 'app/shared/utils/utils';
import { combineLatest } from 'rxjs';
import { DiversityDialogComponent } from './diversity-dialog/diversity-dialog.component';
@Component({
  selector: 'app-diversity',
  templateUrl: './diversity.component.html',
  styleUrls: ['./diversity.component.scss']
})
export class DiversityComponent implements OnInit {
  helpUrl: string;
  supplierCode: string;
  supplierDiversity: SupplierDiversityPropertyValue;

  certificationTypes: AgencyType[];
  diversityTypes: DiversityType[];
  selectedDiversityTypes: DiversityType[];
  selectedAgencyTypes: AgencyType[];
  selectGovernmentTypes: AgencyType[];
  preventativeHold: boolean =false;
  constructor(
    private store: Store<SupplierState>,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog
  ) {
    this.activatedRoute.parent.params.subscribe(params => {
      this.supplierCode = params['code'];
      this.store.dispatch(SetCurrentSupplierCode({ supplierCode: this.supplierCode }));

    });
  }

  ngOnInit(): void {

    this.store.dispatch(new GetSupplierDiversityByCode(this.supplierCode, true));
    this.store.dispatch(new GetDiversityTypes());
    this.store.dispatch(new GetAgencyTypes());

    combineLatest([this.store.select(SelectDiversityTypes), this.store.select(SelectAgencyType), this.store.pipe(select(SelectSupplierDiversity))])
      .subscribe(([diversityTypes, agencytypes, supplierDiveristy]) => {
        var selectedCodes = null;
        this.diversityTypes = diversityTypes;
        this.certificationTypes = agencytypes;
        this.supplierDiversity = supplierDiveristy;
        if (supplierDiveristy && supplierDiveristy.diversityTypes && supplierDiveristy.diversityTypes.newValue && diversityTypes) {
          selectedCodes = supplierDiveristy.diversityTypes.newValue.map(y => y.code);
          this.selectedDiversityTypes = this.diversityTypes.filter(x => selectedCodes.indexOf(x.Code) > -1);
        }
        if (supplierDiveristy && supplierDiveristy.councilCertifications && supplierDiveristy.councilCertifications.newValue && diversityTypes) {
          selectedCodes = supplierDiveristy.councilCertifications.newValue.map(y => y.code);
          this.selectedAgencyTypes = this.certificationTypes.filter(x => selectedCodes.indexOf(x.Code) > -1);
        }
        if (supplierDiveristy && supplierDiveristy.govtCertifications && supplierDiveristy.govtCertifications.newValue && diversityTypes) {
          selectedCodes = supplierDiveristy.govtCertifications.newValue.map(y => y.code);
          this.selectGovernmentTypes = this.certificationTypes.filter(x => selectedCodes.indexOf(x.Code) > -1);
        }
      });
      if (this.supplierCode) { 
        this.store.dispatch(new GetPreventativeInProgress(this.supplierCode,true));
      this.store.pipe(select(SelectPreventativeInProgress)).subscribe(x => {
        if (x) {
          this.preventativeHold = x;
        }
      });
      }
  }

  refresh() {
    this.store.dispatch(new GetSupplierDiversityByCode(this.supplierCode, true));
  }

  openEditDialog() {
    this.dialog.open(DiversityDialogComponent, {
      maxHeight: '750px',
      minWidth: '1000px',
      disableClose: true,
      data: {
        suppliercode: this.supplierCode,
        data: getSupplierDiversity(this.supplierDiversity)
      }
    }).afterClosed().subscribe(x => {
      if (x) {
        this.refresh();
      }
    })
  }

}
